var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2531_55703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50016 15.1673C12.1821 15.1673 15.1668 12.1825 15.1668 8.50065C15.1668 4.81875 12.1821 1.83398 8.50016 1.83398C4.81826 1.83398 1.8335 4.81875 1.8335 8.50065C1.8335 12.1825 4.81826 15.1673 8.50016 15.1673Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56006 6.50038C6.71679 6.05482 7.02616 5.67912 7.43336 5.4398C7.84056 5.20049 8.31932 5.11301 8.78484 5.19285C9.25036 5.2727 9.6726 5.51473 9.97678 5.87606C10.281 6.2374 10.4474 6.69473 10.4467 7.16705C10.4467 8.50038 8.44673 9.16705 8.44673 9.16705",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.834H8.50667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2531_55703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipIcon);
export default __webpack_public_path__ + "static/media/tooltip-icon.843be115efeb93969bd5d5778623414a.svg";
export { ForwardRef as ReactComponent };